<template>
  <el-container class="container">
    <el-header height="70px">

      <Head></Head>
    </el-header>
    <el-main>
      <Main></Main>
    </el-main>
    <el-footer height="130px">
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
import Head from "@/views/Head";
import Footer from "@/views/Footer";
import Main from "@/views/Main";

export default {
  name: "Home",
  components: {
    Head,
    Footer,
    Main,
  },
  data() {
    return {};
  },
  watch: {},
  created() { },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  position: relative;

  .el-header {
    width: 100%;
    padding: 0;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  }

  .el-footer {
    width: 100%;
    padding: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .el-main {
    width: 100%;
    padding: 0;
    background-color: #f9f9f9;
  }
}

@media screen and (max-width: 640px) {
  .container {
    .el-header {
      // height: auto !important;
    }

    .el-footer {
      height: auto !important;
    }

    .el-main {
      padding-top: 0;
    }
  }
}
</style>